// extracted by mini-css-extract-plugin
export default {"control":"control_control__-VLcz"};